import { Component, OnInit, Input } from '@angular/core';

interface ITableHeader {
  id: string;
  name: string;
}

@Component({
  selector: 'ab-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss']
})
export class TableComponent implements OnInit {
  @Input() header: ITableHeader;
  @Input() data: any;
  @Input() cols: Array<any>;

  constructor() {}

  ngOnInit() {}
}

export { ITableHeader };
